export default __webpack_public_path__ + "static/media/ady-teenagerinro-sQ0xXxQdfeY-unsplash.230415fb.jpg";